import { useUser } from "@/hooks/use-user";
import { Redirect, useLocation } from "wouter";
import { storePreviousPageBeforeLogin } from "@/lib/navigation";

interface RequireAuthProps {
  children: React.ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { user } = useUser();
  const [location] = useLocation();

  if (!user) {
    // Store current location for redirect after login
    console.log(
      `[RequireAuth] Unauthorized access to protected route: ${location}, redirecting to login`
    );
    storePreviousPageBeforeLogin(location);
    return <Redirect to="/login" />;
  }

  if (process.env.NODE_ENV === "development") {
    console.log(
      `[RequireAuth] User ${user.id} authenticated, allowing access to ${location}`
    );
  }

  return <>{children}</>;
}

export default RequireAuth;
